/**
 * @file pageVideos.ts
 * @path apps/website/src/data/pageVideos.ts
 * @description
 */

// src/data/pageVideos.ts

import { PageVideo } from "@sirbastians/types";


export const pageVideos: PageVideo[] = [
  {
    path: "/",
    videoUrl: "/assets/Scene2-e6M5RllS.mp4",
    lastReviewed: "2025-10-15",
  },
  {
    path: "/services",
    videoUrl: "/assets/shuttle_2-DUY6caXe.mp4",
    lastReviewed: "2025-10-15",
  },
  {
    path: "/activities",
    videoUrl: "/assets/shuttle_2-DUY6caXe.mp4",
    lastReviewed: "2025-10-15",
  },
  {
    path: "/contact",
    videoUrl: "/assets/video_1-CdZ4Y4IS.mp4",
    lastReviewed: "2025-10-15",
  },
  {
    path: "/join",
    videoUrl: "/assets/Scene1-CuPGDXU4.mp4",
    lastReviewed: "2025-10-15",
  },
];

export const pageVideoMap = new Map<string, PageVideo>(
  pageVideos.map((pv) => [pv.path, pv])
);
